import React, { useContext } from "react";
import { useDispatch } from "react-redux";

import { Button } from "components";
import { ApplicationEntryProgressContext } from "components/contexts";
import {
	DocumentsServiceContext,
	DocumentsTable,
} from "components/tables/documents";
import { applicationDocumentsService } from "services";
import { uiActions } from "store";

const DocumentsTab = ({ applicationId }) => {
	const dispatch = useDispatch();
	const { triggerSave } = useContext(ApplicationEntryProgressContext);

	const handleAddDocument = ({ addDocument }) => {
		dispatch(
			uiActions.showModal("DOCUMENT", {
				onAddDocument(document) {
					if (!applicationId) {
						triggerSave();
					}

					return addDocument({ entityId: applicationId, document });
				},
			}),
		);
	};

	const handleDeleteDocument = ({ document, deleteDocument }) => {
		dispatch(
			uiActions.showModal("CONFIRMATION", {
				title: "Are you sure you want to delete the document?",
				onConfirm() {
					return deleteDocument({
						entityId: applicationId,
						documentId: document.id,
					});
				},
			}),
		);
	};

	const handleViewDocument = ({ document, viewDocument }) => {
		return viewDocument({
			entityId: applicationId,
			documentId: document.id,
		});
	};

	const handleDownLoadDocument = ({ document, downloadDocument }) => {
		return downloadDocument({
			entityId: applicationId,
			documentId: document.id,
		});
	};

	return (
		<DocumentsServiceContext.Provider
			value={{
				key: "applicationDocuments",
				service: applicationDocumentsService,
			}}
		>
			<DocumentsTable
				entityId={applicationId}
				AddDocumentButton={({ addDocument }) => {
					return (
						<Button
							onClick={() => handleAddDocument({ addDocument })}
							value="Add Document"
						/>
					);
				}}
				onViewDocument={handleViewDocument}
				onDownloadDocument={handleDownLoadDocument}
				onDeleteDocument={handleDeleteDocument}
				isDeleteAvailable
			/>
		</DocumentsServiceContext.Provider>
	);
};

export default DocumentsTab;
